const API_URL = import.meta.env.VITE_API_URL || '/api';

/**
 * Parse resume via backend proxy (keeps OpenRouter key server-side).
 * @param {string|string[]} resumeInput - Text or array of base64 data-URLs
 * @param {boolean} isImages
 * @param {'job-application'|'talent'} formType
 * @returns {Promise<Object>}
 */
export const parseResumeWithAI = async (resumeInput, isImages = false, formType = 'job-application') => {
  if (!resumeInput || (typeof resumeInput === 'string' && resumeInput.trim().length === 0)) {
    throw new Error('Resume text is empty');
  }

  if (isImages && (!Array.isArray(resumeInput) || resumeInput.length === 0)) {
    throw new Error('Resume images array is empty');
  }

  const response = await fetch(`${API_URL}/ai/parse-resume`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ resumeInput, isImages, formType }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `Server error: ${response.status}`);
  }

  return response.json();
};

export const isApiKeyConfigured = () => true;
